import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';
import { LigacaoTelemarketing } from '../models/ligacao-telemarketing';
import { TipoFila } from '../models/enum';
import { PermissoesFila } from '../models/filas/permissoes-fila';

@Injectable({
  providedIn: 'root'
})
export class FilaService {

  constructor(private http: HttpClient) { }

  consultarPorId(id: number) {
    return this.http.get<any>(globals.apiUrl + '/api/Fila/BuscarFila',
      { params: new HttpParams().set('id', id.toString()) });
  }

  consultarIndicadores(idFila, idFuncionario) {
    let parametros = new HttpParams();

    if (idFila !== null && idFila !== undefined) {
      parametros = parametros.set('idFila', idFila);
    }

    if (idFuncionario !== null && idFuncionario !== undefined) {
      parametros = parametros.set('idFuncionario', idFuncionario);
    }

    return this.http.get<any>(globals.apiUrl + '/api/Fila/BuscarIndicadores',
      { params: parametros });
  }

  consultarLista(status?) {

    let parametros = new HttpParams();

    if (status !== null && status !== undefined) {
      parametros = parametros.set('status', status);
    }

    return this.http.get<any>(globals.apiUrl + '/api/Fila/ListarFilas',
      { params: parametros });
  }

  consultarPorTipo(tipo) {
    return this.http.get<any>(globals.apiUrl + '/api/Fila/BuscarFilaPorTipo',
      { params: new HttpParams().set('tipo', tipo) });
  }

  consultarGestores(idFila: number) {
    return this.http.get<any>(globals.apiUrl + '/api/Fila/BuscarGestores',
      { params: new HttpParams().set('idFila', idFila.toString()) });
  }

  consultarPermissoes(idFila: number) {
    return this.http.get<PermissoesFila>(globals.apiUrl + `/api/Fila/${idFila}/Permissoes`);
  }

  eGestor(tipoFila) {
    return this.http.get<any>(globals.apiUrl + '/api/Fila/EGestor',
      { params: new HttpParams().set('tipoFila', tipoFila) });
  }

}
